import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import eventVehicleAPI from '@infrastructure/event-vehicle-api';
import familyFestPickupLocationVehicleAPI from '@infrastructure/family-fest-pickup-location-vehicle-api';
export const getEventVehiclesByEventIdAsync = createAsyncThunk('eventVehicle/getByEventId', async ({ eventId, query }, { rejectWithValue }) => {
    try {
        const response = await eventVehicleAPI.getPaginatedEventVehiclesByEventId(eventId, query);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventVehiclesNotPaginatedByEventIdAsync = createAsyncThunk('eventVehicle/getNotPaginatedByEventId', async ({ eventId, searchString }, { rejectWithValue }) => {
    try {
        const response = await eventVehicleAPI.getEventVehiclesByEventId(eventId, searchString);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventVehicleByIdAsync = createAsyncThunk('eventVehicle/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await eventVehicleAPI.getEventVehicleById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createEventVehicleAsync = createAsyncThunk('eventVehicle/create', async (request, { rejectWithValue }) => {
    try {
        const response = await eventVehicleAPI.createEventVehicle(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const checkEventVehicleDuplicatesAsync = createAsyncThunk('eventVehicle/checkDuplicates', async (request, { rejectWithValue }) => {
    try {
        const response = await eventVehicleAPI.checkEventVehicleDuplicates(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateEventVehicleAsync = createAsyncThunk('eventVehicle/update', async (request, { rejectWithValue }) => {
    try {
        const response = await eventVehicleAPI.updateEventVehicle(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteEventVehicleAsync = createAsyncThunk('eventVehicle/delete', async (id, { rejectWithValue }) => {
    try {
        await eventVehicleAPI.deleteEventVehicle(id);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const assignAttendeeToRouteVehicleAsync = createAsyncThunk('eventVehicle/assignAttendeeToRouteVehicle', async (request, { rejectWithValue }) => {
    try {
        const response = await eventVehicleAPI.assignAttendeeToRouteVehicle(request.assignmentIds, request.routeVehicleId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAttendeesByRouteVehicleIdAsync = createAsyncThunk('eventVehicle/getAttendeesByRouteVehicleId', async (routeVehicleId, { rejectWithValue }) => {
    try {
        const response = await eventVehicleAPI.getAttendeesByRouteVehicleId(routeVehicleId);
        return response.data.items;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const sendVehicleInformationToSupplierAsync = createAsyncThunk('eventVehicle/sendVehicleInformationToSupplier', async (vehicleId, { rejectWithValue }) => {
    try {
        await eventVehicleAPI.sendVehicleInformationToSupplier(vehicleId);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getRouteVehiclesByPickupLocationAsync = createAsyncThunk('eventVehicle/getRouteVehiclesByPickupLocation', async (pickupLocationId, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupLocationVehicleAPI.getFamilyFestRouteVehiclesByPickupLocation(pickupLocationId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const exportBirthdayInfoToExcelAsync = createAsyncThunk('eventVehicle/exportBirthdayInfoToExcel', async (vehicleId, { rejectWithValue }) => {
    try {
        const response = await eventVehicleAPI.exportBirthdayInfoToExcel(vehicleId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
